import { useRouter } from "next/router";
import Meta from "../components/Meta";
import StructuredData from "../components/StructuredData";
import HeroSection from "../components/HeroSection";
import PricesTable from "../components/PricesTable";
import useScrollToHash from "../hooks/useScrollToHash";
import RichText from "../components/RichText";
import PreviewBanner from "../components/PreviewBanner";
import { getCompanyInfo } from "../lib/queries/getCompanyInfo";
import { getPageContent } from "../lib/queries/getPageContent";
import { getPrices } from "../lib/queries/getPrices";
import SanityImage from "../components/SanityImage";
import siteConfig from "../lib/siteConfig";

export default function Hinnasto({
  prices,
  companyInfo,
  pageContent,
  preview,
}) {
  const router = useRouter();
  useScrollToHash({ mobileOffset: 90, desktopOffset: 120 });

  return (
    <>
      <Meta pageContent={pageContent} />
      <StructuredData />
      <div id="content">
        {preview && <PreviewBanner />}
        {pageContent.hero && (
          <section>
            <HeroSection content={pageContent.hero} />
          </section>
        )}
        <section className="page-section page-content page-width">
          {!pageContent.hero && (
            <h1 className="page-heading">{pageContent.title}</h1>
          )}
          <div className="md:flex gap-12">
            <div className="md:w-2/3 lg:w-1/2">
              <RichText value={pageContent.introText} className="text-block" />
              <PricesTable prices={prices} />
            </div>
            <div className="md:w-1/3 lg:w-1/2">
              <div className="bg-brand-secondary p-4 lg:p-6 w-auto">
                {pageContent.payment?.title && (
                  <h2 className="subsection-heading mb-3">
                    {pageContent.payment.title}
                  </h2>
                )}
                {pageContent.payment?.body && (
                  <RichText
                    value={pageContent.payment.body}
                    className="text-block mb-8"
                  />
                )}
                {pageContent.compensation?.title && (
                  <h2 className="subsection-heading mb-3">
                    {pageContent.compensation.title}
                  </h2>
                )}
                {pageContent.compensation?.body && (
                  <RichText
                    value={pageContent.compensation.body}
                    className="text-block"
                  />
                )}
              </div>
              {pageContent.additionalImage && (
                <div className="mt-8">
                  <SanityImage
                    image={pageContent.additionalImage}
                    sizes="(max-width: 767px) 100vw, 50vw"
                  />
                </div>
              )}
            </div>
          </div>

          <div className="mb-4 md:text-lg"></div>
        </section>
      </div>
    </>
  );
}

export async function getServerSideProps({ preview = false }) {
  const [prices, companyInfo, pageContent] = await Promise.all([
    getPrices(preview),
    getCompanyInfo(preview),
    getPageContent("hinnasto", preview),
  ]);
  console.log(pageContent);
  return {
    props: {
      prices,
      companyInfo,
      pageContent,
      preview,
    },
    //revalidate: siteConfig.revalidate,
  };
}
